import EnvironmentEnum from './TealiumEnvironmentEnum';
import TealiumHelper from './TealiumHelper';

export { EnvironmentEnum };

export default new TealiumHelper();
